<template>
    <div class="post-activity-template">
        <Card class="pointer" shadow :padding="10" :style="{borderRadius: '0', marginBottom: '10px'}">
            <!-- <router-link tag="div" :to="goTo()" style="color:#aaa"> -->
              <div style="color:#cecece" v-on:click="reRouteUrl()">
                <Icon style="float:right" size="22" type="compose"></Icon>
                {{textAreaPlaceholder}}
              </div>
            <!-- </router-link> -->
        </Card>
    </div>
</template>

<script>

export default {
  name: 'PostActivityComponent',
  data () {
    return {
      activityData: Cons[0].ACTIVITY,
      planId: 0
    }
  },
  computed: {
    profileInfo: {
      get () {
        return this.$store.state.user.info
      }
    }
  },
  methods: {
    goTo () {
      if (this.view === 'journal') { return '/post-update/' + this.pageData.careplan_id } else return '/post-update/' + this.pageData.id
    },
    reRouteUrl() {
      let id
      if(this.view === 'journal-public'){
        id = this.pageData.careplan_id
      }else{
        id = this.pageData.id
      }

      if (this.view === 'organization'){
        this.$router.replace({ 
          query: {
            ...this.$route.query,
            post: id ,
            tab: 'post',
            from: this.view
            }
          })
        this.$store.commit('publicModule/setShowPostItemModal', true)
      }
      else if (this.view === 'resource'){
        this.$router.replace({
          query: {
            post: id,
            tab: 'posts',
            from: this.view
          }
        })
        
        this.$store.commit('publicModule/setShowPostItemModal', true)
      }
      else if (this.view === 'journal-public') {
        this.$router.replace({
          query: { 
            post: this.profileInfo.careplan_id,
            action: 'post',
            tab: 'timeline',
            is_public: true,
            from: this.view,
            is_public: true
          }
        })

        this.$store.commit('publicModule/setShowPostItemModal', true)
      }
      else if (this.view === 'journal-private') {
        this.$router.replace({
          query: { 
            post: this.profileInfo.private_careplan_id,
            action: 'post',
            tab: 'team',
            is_public: false,
            from: this.view,
            is_public: false
          }
        })

        this.$store.commit('publicModule/setShowPostItemModal', true)
      }
    },
    openPostSelectionModal(){
      this.$store.commit('menu/setPostSelectionModal', true)
      this.$store.dispatch('feed/getCareplanInfo', this.$route.query.post).then(res => {
        this.$store.commit('publicModule/setShowPostItemModal', false)
      })
    }
  },
  props: {
    pageData: {
      required: true,
      type: [String, Object]
    },
    view: {
      required: true,
      type: String,
      default: 'journal'
    },
    textAreaPlaceholder: {
      required: false,
      type: String,
      default: 'Write something...'
    }
  }
}
</script>
